module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "number-icon"
  }, [_vm._v(_vm._s(_vm.value))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-690de126!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NumberIcon.vue
// module id = 300
// module chunks = 2